<template>
  <div class="container">
    <el-button
      type="primary"
      @click="emitZipTask"
      size="mini"
      :disabled="selectedLabelTaskId.length === 0"
    >
      生成zip包</el-button
    >
    <el-button type="primary" size="mini" @click="getAllZipTask"
      >查看zip任务</el-button>
    <el-dialog title="zip任务" :visible.sync="zipTaskShow" width="400">
      <el-button type="text" @click="getAllZipTask">刷 新</el-button>
      <el-table height="400" :data="allZipTaskSort" style="width: 100%" v-loading="loading">
        <el-table-column header-align="center" align="center" label="任务备注">
          <template slot-scope="scope">
            {{ scope.row.zip_task_desc || "无备注" }}
          </template>
        </el-table-column>
        <el-table-column prop="create_ts" label="生成时间">
          <template slot-scope="scope">
            {{ scope.row.create_ts | tsToDate }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="columnProp"
          label="状态"
        >
          <template slot-scope="scope">
            <el-tag type="primary" size="mini" v-if="scope.row.status === 0"
            ><i class="el-icon-loading"></i>未完成
            </el-tag>
            <el-tag type="success" size="mini" v-else>已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作" >
          <template slot-scope="scope">
            <zipProgress @refresh="getAllZipTask" :task="scope.row"></zipProgress>
            &nbsp;&nbsp;&nbsp;
            <el-button
              type="text"
              size="mini"
              :disabled="scope.row.status !== 1"
              @click="downLoadZip(scope.row)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiEmitZipTask, apiGetAllZipTask, apiGetZipTaskProgress} from '@/api';
import zipProgress from './zipProgress';
export default {
  name: 'zipTaskBtns',
  components: {
    zipProgress
  },
  data () {
    return {
      detaiDialog: true,
      allZipTask: [],
      zipTaskShow: false,
      loading: false
    };
  },
  props: {
    selectedLabelTaskId: {
      type: Array
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations(['emitLoading', 'removeLoading']),
    ...mapActions([]),
    downLoadZip (row) {
      const {zip_url} = row;
      this.$message.warning('下载中..');
      this.zipTaskShow = false;
      // fileSaver.saveAs(zip_url, row.zip_task_desc || "大图+区域包");
      window.open(zip_url);
    },
    async getAllZipTask () {
      this.zipTaskShow = true;
      this.loading = true;
      try {
        this.allZipTask = await apiGetAllZipTask();
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.message.error('获取失败' + e.message);
      }
    },
    async emitZipTask () {
      this.$prompt('请输入zip备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '请输入备注',
        inputValidator: val => !!val
      }).then(async ({value}) => {
        try {
          this.emitLoading();
          await apiEmitZipTask(value, this.selectedLabelTaskId);
          this.removeLoading();
          this.$message.warning('操作成功');
          this.getAllZipTask();
        } catch (e) {
          this.$message.error('生成失败' + e.message);
          this.removeLoading();
        }
      });
    }
  },
  computed: {
    ...mapGetters([]),
    allZipTaskSort () {
      let list = this.$_.cloneDeep(this.allZipTask);
      list.sort((a, b) => b.create_ts - a.create_ts);
      return list;
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
  .container {
    display: inline-block;
    padding-left: 10px;
  }

</style>
